import React, { createContext, useEffect, useMemo, useState } from 'react';
import debounce from 'lodash.debounce';

export type DisplaySize = {
  displayWidth: number;
  displayHeight: number;
};

export const DisplaySizeContext = createContext<DisplaySize>({ displayHeight: 0, displayWidth: 0 });

export function DisplaySizeContextProvider({ children }) {
  const RESIZE_EVENT_LISTENER_DEBOUNCE_PERIOD_MILLISECONDS = 200;
  const RESIZE_EVENT_NAME = 'resize';
  const [displayWidth, setDisplayWidth] = useState(window.innerWidth);
  const [displayHeight, setDisplayHeight] = useState(window.innerHeight);
  const handleResizeDebounced = useMemo(
    () => debounce(handleResize, RESIZE_EVENT_LISTENER_DEBOUNCE_PERIOD_MILLISECONDS),
    [],
  );

  function handleResize() {
    setDisplayHeight(window.innerHeight);
    setDisplayWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener(RESIZE_EVENT_NAME, handleResizeDebounced);

    return () => {
      window.removeEventListener(RESIZE_EVENT_NAME, handleResizeDebounced);
    };
  }, []);

  return (
    <DisplaySizeContext.Provider value={{ displayWidth, displayHeight }}>
      {children}
    </DisplaySizeContext.Provider>
  );
}
